<template>
  <div data-slot="default" :id="stepManagerWrapperId"
       data-step-manager-wrapper="true">
    <div class="" v-if="debugMode">
      {{ submitDataForm }}
    </div>
    <m-step-manager
        :step-manager-submit-method="onSubmit"
        :form="submitDataForm">
      <slot>
        <m-step-manager-step-1>
          <h1>hello</h1>
        </m-step-manager-step-1>

        <m-step-manager-step-1>
          <h1>world</h1>
        </m-step-manager-step-1>
      </slot>
    </m-step-manager>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import {productForm} from './DashboardProductForm'
import mStepManager from "../../../StepManager/StepManager.vue";
import mStepManagerStep1 from "../../../StepManager/Step/StepManagerStep1.vue";
import {generateRandomString} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {findFeatureWithSelectedName} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

const productFormProp = Object.assign({}, productForm.prop)
const productFormData = Object.assign({}, productForm.data)
const productFormValidation = Object.assign({}, productForm.validation)

export default {
  name: "ProductStepManager900",
  components: {
    mStepManagerStep1,
    mStepManager,
  },
  props: {
    ...productFormProp,
    accessToFeatureExtra: {
      type: Boolean,
      default: true,
    },
    removeFeature: {
      type: Boolean,
      default: true,
    },
    featureImagePicker: {
      type: Boolean,
      default: true,
    },
    openFeatureCategories: {
      type: Boolean,
      default: false,
    },
    showCategoryCollapseButton: {
      type: Boolean,
      default: true,
    },
    debugMode: {
      type: Boolean,
      default: false,
    },
    addFeatureToTitle: {
      default: '',
    }
  },
  data() {
    return {
      submitDataForm: {},
      serverProductForm: {...productFormData},
      stepManagerWrapperId: generateRandomString()
    }
  },
  computed: {
    isPageOnUpdateMode() {
      const routerLink = process.env.NODE_ENV == 'development' ? '4gHmlx5Buv5o2PHW' : this.$route.params.slug;
      return routerLink !== undefined
    },
    pageSlug() {
      return process.env.NODE_ENV == 'development' ? '4gHmlx5Buv5o2PHW' : this.$route.params.slug
    }
  },
  methods: {
    ...mapActions({
      createProduct: "Product/createProduct",
      updateProduct: "Product/updateProduct"
    }),
    async onSubmit() {

      if (this.addFeatureToTitle != '') {


        let result = '';

        let productName = this.submitDataForm.name.split('-').slice(0, -1)

        let featureNames = this.addFeatureToTitle.split(',')

        featureNames.forEach(item => {
          result += findFeatureWithSelectedName(this.submitDataForm, item)
        })

        this.submitDataForm.name = `${productName} - ${result}`
      }


      if (this.isPageOnUpdateMode) {
        await this.updateProduct(this.submitDataForm).then(res=>{
          toast('عملیات با موفقیت انجام شد','عملیات با موفقیت انجام شد')
        })
      } else {
        await this.createProduct(this.submitDataForm)
      }
      await this.setComponentForm()
    },
    async setDataForm() {

      this.submitDataForm = {
        ...productFormData,
      }


      for (let [key, value] of Object.entries(this.$props)) {
        if (Object.keys(productFormProp).indexOf(key) > -1) { // check prop value valid in SubmitDataForm
          this.submitDataForm[key] = value
        }

      }


      if (this.isPageOnUpdateMode) {
        this.submitDataForm = this.serverProductForm
      } else { // set language in create mode
        await this.setLanguageCreateMode()
      }

    },
    async setComponentForm(mode = 'all') {


      await this.$store
          .dispatch("Product/getDashboardProduct", this.pageSlug)
          .then(async (res) => {
            res = res.data.data


            this.serverProductForm.language_id = await res.language_id


            if (mode === 'all') {

              this.serverProductForm.name = await res.name;
              this.serverProductForm.id = await res.id;
              this.serverProductForm.link = await res.raw_link;
              this.serverProductForm.published = this.publishedDefault == false ? (await res.status ? true : false) : this.published
              this.serverProductForm.status = this.publishedDefault == false ? (await res.status ? true : false) : this.published
              this.serverProductForm.mainPreview = await res.thumbnail;
              this.serverProductForm.price = await res.price;
              this.serverProductForm.bonus = await res.bonus;
              this.serverProductForm.order = await res.order;
              this.serverProductForm.quantity = await res.quantity;
              this.serverProductForm.shippingCost = await res.delivery_amount;
              this.serverProductForm.discount = await res.offer;
              this.serverProductForm.is_digital = await res.is_digital == 1 ? true : false;
              this.serverProductForm.variation = await res.variation;

              if (res.description == null) {
                this.serverProductForm.description = "";
              } else {
                this.serverProductForm.description = await res.description;
              }

              if (res.barcode == null) {
                this.serverProductForm.barcode = "";
              } else {
                this.serverProductForm.barcode = await res.barcode;
              }


              if (res.brand == null) {
                this.serverProductForm.selectedBrand = '';
              } else {
                this.serverProductForm.selectedBrand = await res.brand;

              }

              this.serverProductForm.selectedCategory = []
              await res.category.forEach(item => {
                this.serverProductForm.selectedCategory.push(item)
              })

              this.serverProductForm.features = await res.feature_product

              this.serverProductForm.feature_product = await res.feature_product


              await res.images.forEach((image) => {
                this.serverProductForm.preview.push(image.file);
              });


              await res.keywords.forEach((keyword) => {
                this.serverProductForm.keyWords.push(keyword.keyword);
                this.serverProductForm.table.push({name: keyword.keyword});
              });


              const crawlerForm = {
                crawlerable_id: res.id,
                crawlerable_type: 'product',
              }

              await this.$store.dispatch("Crawler/getCrawlers", crawlerForm);

              if (res.variation == 2) { // if product was timable
                const ReservationForm = {
                  product: res.id,
                  month: this.$store.getters['Reservation/getMonth'],
                  year: this.$store.getters['Reservation/getYear'],
                  withoutState: false,
                }

                let DashboardProductRules = await this.$store.dispatch("Reservation/getDashboardProductRules", ReservationForm);
                let reservationTimes = DashboardProductRules.data.data.reservation_times
                this.$store.commit('Reservation/setReservationTimes', reservationTimes)
              }


              const bulkForm = {
                product_id: res.id,
              }
              await this.$store.dispatch("Bulk/getBulks", bulkForm);

            }


            this.serverProductForm.images = []
            this.serverProductForm.preview = []
            await res.images.forEach((image) => {
              this.serverProductForm.preview.push(image);
            });

            this.serverProductForm.order = await res.order;


          })
          .catch((err) => {
            console.log(err);
          });
    },
    async setLanguageCreateMode() {
      let languages = await this.$store.getters['Language/getLanguages'];
      this.submitDataForm.language_id = languages[0].id
    }
  },
  beforeMount() {


    if (this.isPageOnUpdateMode) {
      this.setComponentForm()
    }

    this.setDataForm()

    this.submitDataForm['stepManagerWrapperId'] = this.stepManagerWrapperId


    // set universal props
    this.submitDataForm['props'] = {
      accessToFeatureExtra: this.accessToFeatureExtra,
      removeFeature: this.removeFeature,
      featureImagePicker: this.featureImagePicker,
      openFeatureCategories: this.openFeatureCategories,
      showCategoryCollapseButton: this.showCategoryCollapseButton,
    }

    this.$store.dispatch('StepManager/createStepManagerWrapperState', this.submitDataForm)

  }

}
</script>

<style scoped>

</style>